module.exports = __webpack_public_path__ + "static/activite.57ae5aff.png";